import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight, ImStarFull } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
        <p className="home-about-body">
              <i>
                
              <ImStarFull/>I'm skilled in <span className="purple">full stack</span> website development technologies<br/>
              <ImStarFull/>I'm proficient in <span className="purple">Reactjs,Nodejs,Expressjs</span> and <span className="purple">Mongodb</span><br/>
              <ImStarFull/>I have experience with <span className="purple">WordPress CMS</span> platforms. <br/>
              <ImStarFull/>I specialize in building e-commerce websites and web applications.
              </i>
              <br/>
              <br/>
              Apart from coding, some other activities that I love to do!
            </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> descovering new technologies
            </li>
            <li className="about-activity">
              <ImPointRight /> preparing business startups
            </li>
            
          </ul>

        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
